import React from "react";
import { IconProps } from "./IconProps";

const ArrowRightIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.3172 10.4422L11.6922 16.0672C11.5749 16.1844 11.4159 16.2503 11.25 16.2503C11.0841 16.2503 10.9251 16.1844 10.8078 16.0672C10.6905 15.9499 10.6247 15.7908 10.6247 15.625C10.6247 15.4591 10.6905 15.3001 10.8078 15.1828L15.3664 10.625H3.125C2.95924 10.625 2.80027 10.5591 2.68306 10.4419C2.56585 10.3247 2.5 10.1657 2.5 9.99998C2.5 9.83422 2.56585 9.67525 2.68306 9.55804C2.80027 9.44083 2.95924 9.37498 3.125 9.37498H15.3664L10.8078 4.81717C10.6905 4.69989 10.6247 4.54083 10.6247 4.37498C10.6247 4.20913 10.6905 4.05007 10.8078 3.93279C10.9251 3.81552 11.0841 3.74963 11.25 3.74963C11.4159 3.74963 11.5749 3.81552 11.6922 3.93279L17.3172 9.55779C17.3753 9.61584 17.4214 9.68477 17.4529 9.76064C17.4843 9.83652 17.5005 9.91785 17.5005 9.99998C17.5005 10.0821 17.4843 10.1634 17.4529 10.2393C17.4214 10.3152 17.3753 10.3841 17.3172 10.4422Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M3.5 10.62L16.04 10.62L11.27 15.39C11.07 15.59 11.07 15.9 11.27 16.1C11.47 16.3 11.78 16.3 11.98 16.1L17.6 10.47C17.6 10.47 17.68 10.37 17.71 10.31C17.76 10.19 17.76 10.05 17.71 9.93C17.68 9.87 17.65 9.81 17.6 9.77L11.98 4.15C11.88 4.05 11.75 4 11.63 4C11.51 4 11.37 4.05 11.28 4.15C11.08 4.35 11.08 4.66 11.28 4.86L16.04 9.62L3.5 9.62C3.22 9.62 3 9.84 3 10.12C3 10.4 3.22 10.62 3.5 10.62Z"
            fill={color}
          />
        </svg>
      );
    case "24Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.99941 11.4996C2.99941 11.3007 3.07843 11.1099 3.21908 10.9693C3.35973 10.8286 3.5505 10.7496 3.74941 10.7496L18.4391 10.7496L12.9688 5.28021C12.8991 5.21052 12.8438 5.1278 12.8061 5.03675C12.7684 4.94571 12.749 4.84813 12.749 4.74958C12.749 4.65104 12.7684 4.55345 12.8061 4.46241C12.8438 4.37136 12.8991 4.28864 12.9688 4.21896C13.0385 4.14927 13.1212 4.094 13.2122 4.05629C13.3033 4.01857 13.4009 3.99916 13.4994 3.99916C13.598 3.99916 13.6955 4.01858 13.7866 4.05629C13.8776 4.094 13.9604 4.14927 14.03 4.21896L20.78 10.969C20.8498 11.0386 20.9051 11.1213 20.9428 11.2124C20.9806 11.3034 21 11.401 21 11.4996C21 11.5981 20.9806 11.6957 20.9428 11.7868C20.9051 11.8778 20.8498 11.9606 20.78 12.0302L14.03 18.7802C13.8893 18.9209 13.6984 19 13.4994 19C13.3004 19 13.1095 18.9209 12.9688 18.7802C12.8281 18.6395 12.749 18.4486 12.749 18.2496C12.749 18.0506 12.8281 17.8597 12.9688 17.719L18.4391 12.2496L3.74941 12.2496C3.5505 12.2496 3.35973 12.1706 3.21908 12.0299C3.07843 11.8893 2.99941 11.6985 2.99941 11.4996Z"
            fill={color}
          />
        </svg>
      );
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.53 16.53L18.53 25.53C18.3878 25.6625 18.1998 25.7346 18.0055 25.7312C17.8112 25.7277 17.6258 25.649 17.4884 25.5116C17.351 25.3742 17.2723 25.1888 17.2688 24.9945C17.2654 24.8002 17.3375 24.6122 17.47 24.47L25.1887 16.75H5C4.80109 16.75 4.61032 16.671 4.46967 16.5303C4.32902 16.3897 4.25 16.1989 4.25 16C4.25 15.8011 4.32902 15.6103 4.46967 15.4697C4.61032 15.329 4.80109 15.25 5 15.25H25.1887L17.47 7.53C17.3375 7.38782 17.2654 7.19978 17.2688 7.00548C17.2723 6.81118 17.351 6.62579 17.4884 6.48838C17.6258 6.35096 17.8112 6.27225 18.0055 6.26882C18.1998 6.2654 18.3878 6.33752 18.53 6.47L27.53 15.47C27.6705 15.6106 27.7493 15.8012 27.7493 16C27.7493 16.1987 27.6705 16.3894 27.53 16.53Z"
            fill={color}
          />
        </svg>
      );
    case "32Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.7075 16.7075L18.7075 25.7075C18.5199 25.8951 18.2654 26.0006 18 26.0006C17.7346 26.0006 17.4801 25.8951 17.2925 25.7075C17.1049 25.5199 16.9994 25.2654 16.9994 25C16.9994 24.7346 17.1049 24.4801 17.2925 24.2925L24.5863 17H5C4.73478 17 4.48043 16.8947 4.29289 16.7071C4.10536 16.5196 4 16.2652 4 16C4 15.7348 4.10536 15.4804 4.29289 15.2929C4.48043 15.1054 4.73478 15 5 15H24.5863L17.2925 7.70751C17.1049 7.51987 16.9994 7.26537 16.9994 7.00001C16.9994 6.73464 17.1049 6.48015 17.2925 6.29251C17.4801 6.10487 17.7346 5.99945 18 5.99945C18.2654 5.99945 18.5199 6.10487 18.7075 6.29251L27.7075 15.2925C27.8005 15.3854 27.8742 15.4957 27.9246 15.6171C27.9749 15.7385 28.0008 15.8686 28.0008 16C28.0008 16.1314 27.9749 16.2615 27.9246 16.3829C27.8742 16.5043 27.8005 16.6146 27.7075 16.7075Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default ArrowRightIcon;
